import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useHistory } from "react-router-dom";
import EpaProfile from "./EpaProfile";
import FacilityAddress from "./FacilityAddress";
import MailingAddress from "./MailingAddress";
import OwnerBanner from "./OwnerBanner";
import ContactBanner from "./ContactBanner";
import CesInfo from "./CESInfo";
import FacilityMiniMap from "./FacilityMiniMap";
import ManifestSection from "./ManifestSection";
import Verifications from "./Verifications";
import NaicsListGrid from "./NaicsListGrid";
import { formatFacilityCode } from "../../shared/functions/Functions";
import WasteCodeMatrixGrid from "./WasteCodeMatrixGrid";
import { Section, Loading } from "../../shared";
import { useIsRegulator } from "../../../hooks";
import {
  Col,
  Row,
  Alert,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import usePrevious from "../../../hooks/usePrevious";
import CallerInfo from "./CallerInfo";

function FacilityProfile(props) {
  const isRegulator = useIsRegulator();
  const [isFetching, setIsFetching] = useState(true);
  const [facility, setFacility] = useState([]);
  const params = useParams();
  const history = useHistory();
  const [handlerId, setHandlerId] = useState(params.id);
  const [handlerIdTemp, setHandlerIdTemp] = useState("");
  const prevHandlerId = usePrevious(handlerId);
  const [manifestToggle, setManifestToggle] = useState(true);
  const toggleManifest = () => setManifestToggle(!manifestToggle);
  const [matrixToggle, setMatrixToggle] = useState(false);
  const toggleMatrix = () => setMatrixToggle(!matrixToggle);

  const formatZipCode = (zipcode) => {
    return zipcode.slice(0, 5);
  };

  const fetchFacility = async () => {
    setIsFetching(true);
    setHandlerIdTemp(handlerId);
    if (handlerId !== "" && prevHandlerId !== handlerId) {
      history.push(`/facility/${handlerId}`);
    }
    await axios
      .get(`api/v1/hwts/search/facility?epaid=${handlerId}`)
      .then((facility) => {
        setFacility([...facility.data]);
        setIsFetching(false);
      });
  };

  const navigateToHandler = (e) => {
    e.preventDefault();
    setHandlerId(e.target.value);
  };

  useEffect(() => {
    if (handlerId !== "" && prevHandlerId !== handlerId) {
      fetchFacility();
    }
  }, []);

  useEffect(() => {
    setHandlerId(params.id)
  }, [params]);

  return (
    <div>
      <Section title="Handler Profile" type={"standout"} />
      {isFetching ? (
        <Loading />
      ) : facility.length < 1 ? (
        <div id="page-container" className="container">
          <Row className="mx-0">
            <ol className="breadcrumb">
              <li>
                <Link to="/" title="Home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" title="search">
                  Search
                </Link>
              </li>
              <li className="active">View Facility Profile</li>
            </ol>
            <span className="facility-search-id ml-auto pt-2 btn-block-xs">
              <Form onSubmit={fetchFacility} style={{ marginBottom: 5 }}>
                <Form.Row>
                  <InputGroup>
                    <Form.Control
                      placeholder="Search for an ID Number"
                      aria-label="Search for an ID Number"
                      aria-describedby="basic-addon2"
                      type="text"
                      onChange={navigateToHandler}
                      id="epaid"
                      name="epaid"
                    />
                    <InputGroup.Append>
                      <Button
                        disabled={isFetching}
                        type="submit"
                        variant="outline-secondary"
                        style={{ height: "38px", borderColor: "#a8b3bd" }}
                      >
                        <span className="ca-gov-icon-search formearch">
                          <span className="sr-only">Search</span>
                        </span>
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </Form.Row>
              </Form>
            </span>
          </Row>
          <hr style={{ marginTop: 0 }} />
          <div className="d-flex p-2">
            <div className="title" style={{ fontSize: "1.25rem" }}>
              Handler Profile information for ID Number:{" "}
              <u>{handlerIdTemp.toUpperCase()}</u> is not available in HWTS. Contact the issuing agency for current handler
              status and information.
            </div>
          </div>
        </div>
      ) : (
            <div id="page-container" className="container">
              {facility && (
                <div>
                  <Row className="mx-0">
                    <ol className="breadcrumb">
                      <li>
                        <Link to="/" title="Home">
                          Home
                    </Link>
                      </li>
                      <li>
                        <Link to="/search" title="search">
                          Search
                    </Link>
                      </li>
                      <li className="active">Handler Profile</li>
                    </ol>
                    <span className="facility-search-id ml-auto pt-2 btn-block-xs">
                      <Form onSubmit={fetchFacility} style={{ marginBottom: 5 }}>
                        <Form.Row>
                          <InputGroup>
                            <Form.Control
                              placeholder="Search for an ID Number"
                              aria-label="Search for an ID Number"
                              aria-describedby="basic-addon2"
                              type="text"
                              onChange={navigateToHandler}
                              id="epaid"
                              name="epaid"
                            />
                            <InputGroup.Append>
                              <Button
                                disabled={isFetching}
                                type="submit"
                                variant="outline-secondary"
                                style={{ height: "38px", borderColor: "#a8b3bd" }}
                              >
                                <span className="ca-gov-icon-search formearch">
                                  <span className="sr-only">Search</span>
                                </span>
                              </Button>
                            </InputGroup.Append>
                          </InputGroup>
                        </Form.Row>
                      </Form>
                    </span>
                  </Row>
                  <hr style={{ marginTop: 0 }} />
                  <Row className="mx-0 px-0 mb-2">
                    <div style={{ fontSize: "1.4em" }}>
                      {facility[0].EpaId.toUpperCase()} -{" "}
                      {facility[0].FacName.toUpperCase()}
                    </div>
                    {facility[0] ? (
                      <div
                        className="ml-auto"
                        style={{
                          textAlign: "right",
                          fontSize: "1.4em",
                        }}
                      >
                        {!facility[0].IsTribal ? 
                        <div>
                        Status:
                        <span
                          className="ml-1"
                          style={{
                            color:
                              facility[0].CatStatus.toLowerCase() === "active"
                                ? "green"
                                : "red",
                          }}
                        >
                          {facility[0].CatStatus}
                        </span>
                        </div>
                        : <div><b>Tribal</b></div>}
                      </div>
                    ) : null}
                  </Row>
                  {facility[0] && facility[0].IsTribal ? (
                    <Row className="mt-2 mx-0">
                      <Alert className="full-width mb-0" variant="danger">
                      DTSC is no longer responsible for issuing or managing hazardous waste ID numbers for sites located on federally recognized tribal land in California. All issuance and maintenance of ID numbers for these sites are now done through U.S. EPA Region 9. Any information displayed in HWTS for tribal ID numbers is not an authoritative source of record. Any authoritative information pertaining to ID numbers on federally recognized tribal land is stored within <a href = "https://rcrainfo.epa.gov/" target="_blank" rel="noreferrer">U.S. EPA's RCRAInfo System</a>. For questions regarding tribal ID numbers contact&nbsp;
                      <a href = "mailto: r9landsubmit@epa.gov">r9landsubmit@epa.gov</a>.
                  </Alert>
                    </Row>
                  ) : null}
                  <hr />
                  {facility[0].DD_Latitude !== 0 ? (
                    <Row>
                      <Col>
                        <div className="facility-minimap" key={facility[0].EpaId}>
                          <FacilityMiniMap
                            EPA_ID={facility[0].EpaId}
                            FAC_ST1={facility[0].FacStr1}
                            FAC_CITY={facility[0].FacCity}
                            FAC_STATE={facility[0].FacState}
                            DD_Latitude={facility[0].DDLatitude}
                            DD_Longitude={facility[0].DDLongitude}
                          />
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                  <br />
                  <Row>
                    <Col md="6" xs="12">
                      <EpaProfile
                        EPA_ID={facility[0].EpaId.toUpperCase()}
                        FacilityName={facility[0].FacName.toUpperCase()}
                        IS_TRIBAL={facility[0].IsTribal}
                        Status={facility[0].CatStatus}
                        NAICS={facility[0].FacilityNaics}
                        EPATYPEIND={facility[0].EpaTypeInd}
                        EPACATEGORY={facility[0].EpaCategory}
                        INACTIVE_DATE={facility[0].InactiveDate}
                        CREATE_DATE={facility[0].CreateDate}
                        LAST_UPDATED={facility[0].LastActDate}
                        FACILITY_TYPES={formatFacilityCode(
                          facility[0].FacilityTypeCode
                        ).join(",")}
                        CES_SCORE={facility[0].CESScore}
                        CES_PCT={facility[0].CESPct}
                        TRANS_STATUS={facility[0].TransporterStatus}
                        TRANS_ID={facility[0].TransID}
                      />
                    </Col>
                    <Col md="3" xs="12">
                      <FacilityAddress
                        FAC_ST1={facility[0].FacStr1.toUpperCase()}
                        FAC_CITY={facility[0].FacCity.toUpperCase()}
                        CNTY_NAME={facility[0].CountyName.toUpperCase()}
                        FAC_ZIP={formatZipCode(facility[0].FacZip)}
                        DD_Latitude={facility[0].DDLatitude}
                        DD_Longitude={facility[0].DDLongitude}
                        TRANS_ID={facility[0].TransID}
                      />
                    </Col>
                    {!facility[0].IsTribal ? (
                    <Col md="3" xs="12">
                      <MailingAddress
                        EPA_ID={facility[0].EpaId.toUpperCase()}
                        MAIL_ST1={facility[0].MailStr1.toUpperCase()}
                        MAIL_CITY={facility[0].MailCity.toUpperCase()}
                        MAIL_STATE={facility[0].MailState.toUpperCase()}
                        MAIL_ZIP={formatZipCode(facility[0].MailZip)}
                        TRANS_ID={facility[0].TransID}
                      />
                    </Col>
                    ) : null}
                  </Row>
                  {!facility[0].IsTribal ? (
                  <div>
                  <Row>
                    <Col md="4" xs="12">
                      <OwnerBanner
                        EPA_ID={facility[0].EpaId.toUpperCase()}
                        OWNER_NAME={facility[0].OwnerName.toUpperCase()}
                        OWNER_ST1={facility[0].OwnerStr1.toUpperCase()}
                        OWNER_CITY={facility[0].OwnerCity.toUpperCase()}
                        OWNER_STATE={facility[0].OwnerState.toUpperCase()}
                        OWNER_ZIP={formatZipCode(facility[0].OwnerZip)}
                        OWNER_PHONE={facility[0].OwnerPhone}
                        isRegulator={isRegulator}
                      />
                    </Col>
                    <Col md="4" xs="12">
                      <CallerInfo
                        Call_Bus_Name={facility[0].CallBusName}
                        Call_Name={facility[0].CallName}
                        Call_Str1={facility[0].CallStr1}
                        Call_Str2={facility[0].CallStr2}
                        Call_City={facility[0].CallCity}
                        Call_ST={facility[0].CallST}
                        Call_ZIP={facility[0].CallZIP}
                      />
                     </Col>
                    <Col md="4" xs="12">
                      <ContactBanner
                        EPA_ID={facility[0].EpaId}
                        CONTACT_NAME={facility[0].ContactName.toUpperCase()}
                        CONTACT_ST1={facility[0].ContactStr1.toUpperCase()}
                        CONTACT_CITY={facility[0].ContactCity.toUpperCase()}
                        CONTACT_STATE={facility[0].ContactState.toUpperCase()}
                        CONTACT_ZIP={formatZipCode(facility[0].ContactZip)}
                        CONTACT_PHONE={facility[0].ContactPhone}
                        CONTACT_EMAIL={facility[0].ContactEmail}
                        isRegulator={isRegulator}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6" xs="12">
                      <CesInfo
                        CENSUS_TRACT={facility[0].CESTract}
                        CES_PCT={facility[0].CESPct}
                        POLLUTION_BURDEN={facility[0].CESPollution}
                        HAZ_WASTE_PCT={facility[0].CESHazWaste}
                        POPULATION={facility[0].CESPopulation}
                        POPULATION_CHAR={facility[0].CESPopulationChar}
                        CLEANUP_SITES={facility[0].CESCleanup}
                        GROUND_WATER={facility[0].CESGroundWater}
                        SOLID_WASTE={facility[0].CESSolidWaste}
                      />
                    </Col>
                    <Col md="6" xs="12">
                      <NaicsListGrid EPA_ID={facility[0].EpaId} />
                    </Col>
                  </Row>
                  </div>
                  ) : null}
                  <Row>
                    <Col md="12" xs="12">
                      <Verifications EPA_ID={facility[0].EpaId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="panel-group accordion " id="manifest-accordion" role="tablist" aria-multiselectable="true">
                        <div className="panel panel-default manifests-card">
                          <div className="panel-heading px-1" role="tab" id="manifest-heading" style={{ backgroundColor: "rgb(4, 107, 153)" }}>
                            <h3 className="panel-title h4">
                              <a className="manifest-card-header collapsed" data-toggle="collapse" data-parent="#manifest-accordion" href="#collapseManifests" aria-controls="collapseOne" onClick={toggleManifest}>
                                Manifests
                                <i className={`ca-gov-icon-caret-${manifestToggle === false ? "right" : "down"} ml-auto`} style={{ color: "white" }} />
                              </a>
                            </h3>
                          </div>
                          <div id="collapseManifests" className={`panel-collapse collapse ${manifestToggle === true && "show"}`} role="tabpanel" aria-labelledby="manifest-heading" style={{ backgroundColor: "rgb(4, 107, 153)" }}>
                            <div className="panel-body">
                              {manifestToggle === true && <ManifestSection EPA_ID={props.match.params.id} />}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="panel-group accordion " id="matrix-accordion" role="tablist" aria-multiselectable="true">
                        <div className="panel panel-default manifests-card">
                          <div className="panel-heading px-1" role="tab" id="matrix-heading" style={{ backgroundColor: "rgb(4, 107, 153)" }}>
                            <h3 className="panel-title h4">
                              <a className="manifest-card-header collapsed" data-toggle="collapse" data-parent="#matrix-accordion" href="#collapseMatrix" aria-controls="collapseOne" onClick={toggleMatrix}>
                                Waste Code Matrix
                                <i className={`ca-gov-icon-caret-${matrixToggle === false ? "right" : "down"} ml-auto`} style={{ color: "white" }} />
                              </a>
                            </h3>
                          </div>
                          <div id="collapseMatrix" className={`panel-collapse collapse ${matrixToggle === true && "show"}`} role="tabpanel" aria-labelledby="matrix-heading" style={{ backgroundColor: "rgb(4, 107, 153)" }}>
                            <div className="panel-body">
                              {matrixToggle === true && <WasteCodeMatrixGrid epaId={facility[0].EpaId} />}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          )}
    </div>
  );
}

export default FacilityProfile;
